import { createReducer } from 'redux-act';

import {
  PROMOTIONS_FETCH_DATA_INIT,
  PROMOTIONS_FETCH_DATA_SUCCESS,
  PROMOTIONS_FETCH_DATA_FAIL,
  PROMOTIONS_DELETE_PROMOTION_INIT,
  PROMOTIONS_DELETE_PROMOTION_SUCCESS,
  PROMOTIONS_DELETE_PROMOTION_FAIL,
  PROMOTIONS_CLEAR_DATA,
  PROMOTIONS_CREATE_PROMOTION_INIT,
  PROMOTIONS_CREATE_PROMOTION_SUCCESS,
  PROMOTIONS_CREATE_PROMOTION_FAIL,
  PROMOTIONS_MODIFY_PROMOTION_INIT,
  PROMOTIONS_MODIFY_PROMOTION_SUCCESS,
  PROMOTIONS_MODIFY_PROMOTION_FAIL,
  PROMOTIONS_CLEAN_UP,
  PROMOTIONS_CLEAR_DATA_LOGOUT,
  PROMOTIONS_SYNC_PROMOTION_INIT,
  PROMOTIONS_SYNC_PROMOTION_SUCCESS,
  PROMOTIONS_SYNC_PROMOTION_FAIL,
} from 'state/actions/promotion';

const initialState = {
  list: [],
  promotion: {},
  loading: false,
  downloading: false,
  error: {
    errors: null,
    message: '',
  },
  success: false,
  deleted: false,
};

export const promotionReducer = createReducer(
  {
    [PROMOTIONS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [PROMOTIONS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      promotion: payload.promotion || initialState.promotion,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PROMOTIONS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROMOTIONS_DELETE_PROMOTION_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROMOTIONS_DELETE_PROMOTION_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      deleted: true,
    }),
    [PROMOTIONS_DELETE_PROMOTION_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROMOTIONS_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [PROMOTIONS_CREATE_PROMOTION_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROMOTIONS_CREATE_PROMOTION_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [PROMOTIONS_CREATE_PROMOTION_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROMOTIONS_MODIFY_PROMOTION_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROMOTIONS_MODIFY_PROMOTION_SUCCESS]: (state) => ({
      ...state,

      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [PROMOTIONS_MODIFY_PROMOTION_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROMOTIONS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: false,
      deleted: false,
    }),
    [PROMOTIONS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [PROMOTIONS_SYNC_PROMOTION_INIT]: (state) => ({
      ...state,
      downloading: true,
    }),
    [PROMOTIONS_SYNC_PROMOTION_SUCCESS]: (state) => ({
      ...state,
      downloading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [PROMOTIONS_SYNC_PROMOTION_FAIL]: (state, payload) => ({
      ...state,
      downloading: false,
      error: payload.error,
    }),
  },
  initialState
);
